import React from "react";
import { MdEmail } from "react-icons/md";
import { FiPhone } from "react-icons/fi";
import { FaWhatsapp, FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import { Link } from "react-router-dom";

function Footer() {
  const styles = {
    footer: {
      backgroundColor: "#0a1628", // Dark blue - matches TRAIL
      color: "#ffffff",
      padding: "30px 0 20px 0",
      fontFamily: "Segoe UI, sans-serif",
      borderTop: "1px solid rgba(255, 255, 255, 0.06)",
      width: "100%",
    },
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "0 20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "20px",
    },
    brand: {
      display: "flex",
      flexDirection: "column",
      marginBottom: "0.5rem",
    },
    brandLink: {
      color: "#ffffff",
      textDecoration: "none",
      fontSize: "24px",
      fontWeight: "bold",
      marginBottom: "5px",
      transition: "color 0.3s ease, opacity 0.3s ease",
      letterSpacing: "0.5px",
      fontFamily: "'Georgia', serif",
    },
    tagline: {
      fontSize: "14px",
      color: "rgba(255, 255, 255, 0.5)",
      fontStyle: "italic",
      letterSpacing: "0.5px",
    },
    contact: {
      display: "flex",
      flexDirection: "column",
      gap: "0.8rem",
      fontSize: "14px",
    },
    contactItem: {
      display: "flex",
      alignItems: "center",
      gap: "0.6rem",
      color: "rgba(255, 255, 255, 0.7)",
      transition: "color 0.3s ease",
      cursor: "pointer",
    },
    contactIcon: {
      color: "rgba(255, 255, 255, 0.5)",
      fontSize: "18px",
      transition: "color 0.3s ease",
    },
    socials: {
      display: "flex",
      gap: "15px",
    },
    icon: {
      color: "rgba(255, 255, 255, 0.6)",
      fontSize: "28px",
      transition: "transform 0.3s ease, color 0.3s ease, background-color 0.3s ease",
      cursor: "pointer",
      padding: "10px",
      borderRadius: "50%",
      backgroundColor: "rgba(255, 255, 255, 0.04)",
      border: "1px solid rgba(255, 255, 255, 0.06)",
      width: "50px",
      height: "50px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    copyright: {
      textAlign: "center",
      paddingTop: "20px",
      marginTop: "20px",
      borderTop: "1px solid rgba(255, 255, 255, 0.04)",
      fontSize: "13px",
      color: "rgba(255, 255, 255, 0.3)",
      width: "100%",
      letterSpacing: "0.5px",
    },
  };

  const handleMouseEnter = (e) => {
    e.target.style.color = "#ffffff";
    e.target.style.transform = "translateY(-3px) scale(1.1)";
    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.08)";
    e.target.style.borderColor = "rgba(255, 255, 255, 0.15)";
  };

  const handleMouseLeave = (e) => {
    e.target.style.color = "rgba(255, 255, 255, 0.6)";
    e.target.style.transform = "translateY(0) scale(1)";
    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.04)";
    e.target.style.borderColor = "rgba(255, 255, 255, 0.06)";
  };

  const handleBrandHover = (e) => {
    e.target.style.opacity = "0.8";
  };

  const handleBrandLeave = (e) => {
    e.target.style.opacity = "1";
  };

  const handleContactHover = (e) => {
    e.currentTarget.style.color = "#ffffff";
    const icon = e.currentTarget.querySelector('svg');
    if (icon) {
      icon.style.color = "#ffffff";
    }
  };

  const handleContactLeave = (e) => {
    e.currentTarget.style.color = "rgba(255, 255, 255, 0.7)";
    const icon = e.currentTarget.querySelector('svg');
    if (icon) {
      icon.style.color = "rgba(255, 255, 255, 0.5)";
    }
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.brand}>
          <Link
            to="/"
            style={styles.brandLink}
            onMouseEnter={handleBrandHover}
            onMouseLeave={handleBrandLeave}
          >
            WangoTrailSafaris
          </Link>
          <p style={styles.tagline}>Explore · Discover · Experience</p>
        </div>

        <div style={styles.contact}>
          <div 
            style={styles.contactItem}
            onMouseEnter={handleContactHover}
            onMouseLeave={handleContactLeave}
          >
            <MdEmail style={styles.contactIcon} />
            <span>wangotrailsafaris@gmail.com</span>
          </div>
          <div 
            style={styles.contactItem}
            onMouseEnter={handleContactHover}
            onMouseLeave={handleContactLeave}
          >
            <FiPhone style={styles.contactIcon} />
            <span>+254706019613</span>
          </div>
          <div 
            style={styles.contactItem}
            onMouseEnter={handleContactHover}
            onMouseLeave={handleContactLeave}
          >
            <FaWhatsapp style={styles.contactIcon} />
            <span>+254706019613</span>
          </div>
        </div>

        <div style={styles.socials}>
          <FaFacebookF
            style={styles.icon}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            aria-label="Facebook"
          />
          <FaTwitter
            style={styles.icon}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            aria-label="Twitter"
          />
          <FaInstagram
            style={styles.icon}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            aria-label="Instagram"
          />
        </div>
      </div>
      <div style={styles.copyright}>
        &copy; {new Date().getFullYear()} WangoTrailSafaris. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;